/*jshint esversion: 6 */
window.devMode = !false;
import Vue from 'vue';
import _ from 'lodash';
import "luxon";

import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuex from "vuex";


let supportLangs = ["ru", "kz", "en", "zh"];
let searchLang = location.search.replace("?lang=", "");

if (supportLangs.indexOf(searchLang) != -1) {
    history.pushState(0, '', '/');
    localStorage.lang = searchLang;
} else {
    searchLang = "";
}

Vue.mixin({
    data() {
        return {
            l_: _
        }
    },
    computed: {
        lang() {
            return searchLang ? searchLang : this.$store.state.lang ? this.$store.state.lang : "ru";
        }
    },
    methods: {
        rerender() {
            this.show = false
            this.$nextTick(() => {
                this.show = true
                console.log('re-render start')
                this.$nextTick(() => {
                    console.log('re-render end')
                })
            })
        }
    }
});


Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuex);


import "./imports/prototypes/String.prototype.kzToLatin.js";
import "./imports/prototypes/Number.prototype.toPhrase.js";
import "./imports/prototypes/Array.prototype.findById.js";
import "./imports/prototypes/Array.prototype.updateById";
import "./imports/prototypes/Array.prototype.removeById";
import "./imports/prototypes/Array.prototype.toTree";
import "./imports/prototypes/Array.prototype.getOptions";
import "./imports/prototypes/Date.js";
import "./imports/_i.js";
import "./imports/toPhrase.js";
import VueGearboxApi from "./imports/gearbox-tools.js";
Vue.use(VueGearboxApi);
import "./imports/basic-components.js";
import "./imports/inspire-addons.js";
import "./imports/bbcode.js";
import "./classes/iFormData.js";

import "./imports/graphql.js";

import GearboxAuth from './modules/auth/auth-graphql.gearbox-plugin.js';
Vue.use(GearboxAuth);


Vue.http.options.root = '//' + location.host + '/api/v1';
Vue.http.options.credentials = true;
Vue.config.productionTip = false;
